import { ChangeDetectionStrategy, Component, ElementRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AddBasketLineItemsModel } from 'src/business/services/client.generated';
import { FormControlValueAccessor } from 'src/core-lib/value-accessors/form-control-value-accessor.abstract';
import { debounce } from 'src/utils/debounce';
import { DomUtils } from 'src/utils/dom.util';
import { BasketService } from '../../services/basket.service';


@Component({
    selector: 'app-basket-quantity',
    templateUrl: './basket-quantity.component.html',
    styleUrls: ['./basket-quantity.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: BasketQuantityComponent
        }
    ]
})
export class BasketQuantityComponent {
    @Input() quantity: number = 1;
    @Input() step: number = 1;

    constructor(
        private elm: ElementRef,
        private basketService: BasketService
    ) {}

    pressedNumber = DomUtils.pressedNumber;
    pastedNumber = DomUtils.pastedNumber;
    setQuantity = debounce(() => {
        var formElm = this.elm.nativeElement.closest('form');
        var data = new FormData(formElm);
        var form: AddBasketLineItemsModel = {
            groupLine: { sku: data.get('groupLine') as string, quantity: +data.get('quantity') },
            replaces: data.get('line') as string,
            lines: data.getAll('addon').map(addon => ({ sku: addon as string, quantity: +data.get('quantity') }))
        };
        this.basketService.updateOrCreateLines(form);
        return false;
    }, 700);

    setStep(step: number) {
        var inputElm = this.elm.nativeElement.querySelector('input');
        inputElm.value = +inputElm.value + step;
        this.setQuantity();
    }
}
